/** Key used to identify postMessage messages from MyCM. */
export const ETHICO_MYCM_CONFIG_KEY = 'ethico-myCM-config';
